(() => {
  if (window.__BHD_V21_QA_FIXES__) return;
  window.__BHD_V21_QA_FIXES__ = true;
  document.documentElement.dataset.bhdV21QaFixes = 'loaded';

  const CONSENT_KEY = 'bhdCookieConsentV21';
  const WISHLIST_KEY = 'bhdWishlistV1';
  const launchCache = new Map();
  const isSpanish = () => (document.documentElement.lang || '').toLowerCase().startsWith('es');

  const hideConsent = () => {
    document.querySelectorAll('cookie-banner .cookie-banner').forEach((banner) => {
      banner.classList.remove('is-active', 'is-closing');
      banner.hidden = true;
    });
  };

  const storedConsent = () => {
    try { return localStorage.getItem(CONSENT_KEY); } catch (_) { return null; }
  };

  document.addEventListener('click', (event) => {
    const consent = event.target.closest('cookie-banner button[name="accept"], cookie-banner button[name="decline"]');
    if (!consent) return;
    try { localStorage.setItem(CONSENT_KEY, consent.name); } catch (_) {}
    hideConsent();
  }, true);

  const normalizeHandle = (value = '') => {
    const match = String(value).match(/\/products\/([^/?#]+)/i);
    return match ? decodeURIComponent(match[1]) : '';
  };

  const launchStateFor = async (handle) => {
    if (!handle) return 'normal';
    if (launchCache.has(handle)) return launchCache.get(handle);
    const promise = fetch(`${window.Shopify?.routes?.root || '/'}products/${encodeURIComponent(handle)}`, {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' }
    }).then((response) => response.text()).then((html) => {
      const documentCopy = new DOMParser().parseFromString(html, 'text/html');
      const gate = documentCopy.querySelector('[data-bhd-launch-gate]');
      const explicitPrelaunch = gate?.dataset?.state === 'prelaunch';
      const prelaunchControls = Boolean(documentCopy.querySelector('[data-bhd-release-alert], .bhd-launch-gate--prelaunch'));
      return explicitPrelaunch || prelaunchControls ? 'prelaunch' : 'normal';
    }).catch(() => 'unknown');
    launchCache.set(handle, promise);
    return promise;
  };

  const savedItems = () => {
    try {
      const parsed = JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (_) { return []; }
  };

  const syncWishlistSummary = () => {
    const page = document.querySelector('[data-bhd-wishlist-page]');
    if (!page) return;
    const cards = [...page.querySelectorAll('[data-bhd-wishlist-item]')];
    const available = cards.filter((card) => {
      const add = card.querySelector('[data-bhd-wishlist-add]');
      return add && !add.disabled && card.dataset.bhdLaunchState !== 'prelaunch';
    }).length;
    const count = page.querySelector('[data-bhd-wishlist-available-count]');
    const countText = isSpanish()
      ? `${available} ${available === 1 ? 'DISPONIBLE' : 'DISPONIBLES'}`
      : `${available} AVAILABLE`;
    if (count && count.textContent !== countText) count.textContent = countText;
    const addAll = page.querySelector('[data-bhd-wishlist-add-all]');
    if (addAll) addAll.disabled = available === 0;
  };

  const gateWishlist = async () => {
    const cards = [...document.querySelectorAll('[data-bhd-wishlist-item]')];
    const uncheckedCards = cards.filter((card) => card.dataset.bhdLaunchChecked !== 'true');
    if (!uncheckedCards.length) return;
    await Promise.all(uncheckedCards.map(async (card) => {
      card.dataset.bhdLaunchChecked = 'true';
      const handle = card.dataset.bhdWishlistItem || normalizeHandle(card.querySelector('a[href*="/products/"]')?.href);
      const state = await launchStateFor(handle);
      card.dataset.bhdLaunchState = state;
      if (state !== 'prelaunch') return;
      const add = card.querySelector('[data-bhd-wishlist-add]');
      if (add) {
        add.disabled = true;
        add.textContent = isSpanish() ? 'PRÓXIMAMENTE' : 'COMING SOON';
        add.setAttribute('aria-disabled', 'true');
      }
      const badge = card.querySelector('.bhd-wishlist-item__soldout') || document.createElement('span');
      badge.className = 'bhd-wishlist-item__soldout';
      badge.textContent = isSpanish() ? 'PRÓXIMAMENTE' : 'COMING SOON';
      if (!badge.parentElement) card.querySelector('.bhd-wishlist-item__media')?.appendChild(badge);
    }));
    syncWishlistSummary();
  };

  document.addEventListener('click', async (event) => {
    const individual = event.target.closest('[data-bhd-wishlist-add]');
    if (individual?.closest('[data-bhd-wishlist-item]')?.dataset.bhdLaunchState === 'prelaunch') {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    const addAll = event.target.closest('[data-bhd-wishlist-add-all]');
    if (!addAll) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const lines = [];
    for (const item of savedItems()) {
      if (!item.variantId || !item.variantAvailable) continue;
      if (await launchStateFor(item.handle) === 'prelaunch') continue;
      lines.push({ id: Number(item.variantId), quantity: 1 });
    }
    if (!lines.length) return;
    await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: lines })
    });
    document.dispatchEvent(new CustomEvent('cart:updated'));
    window.location.assign(`${window.Shopify?.routes?.root || '/'}cart`);
  }, true);

  const fixPredictiveSearch = () => {
    document.querySelectorAll('[data-predictive-search-live-region-count-value]').forEach((node) => {
      if (!node.textContent.includes('I18n Error')) return;
      const input = document.querySelector('input[type="search"][name="q"]');
      const terms = input?.value?.trim() || '';
      const products = document.querySelectorAll('#predictive-search-results-products-list > li').length;
      node.textContent = isSpanish()
        ? `${products} resultados encontrados para “${terms}”`
        : `${products} results found for “${terms}”`;
    });
  };

  const boot = () => {
    document.documentElement.dataset.bhdV21QaFixesBoot = 'started';
    if (storedConsent()) hideConsent();
    gateWishlist();
    fixPredictiveSearch();
    let observerTimer;
    new MutationObserver(() => {
      window.clearTimeout(observerTimer);
      observerTimer = window.setTimeout(() => {
      if (storedConsent()) hideConsent();
      gateWishlist();
      fixPredictiveSearch();
      }, 120);
    }).observe(document.body, { childList: true, subtree: true });
  };

  window.setTimeout(boot, 0);
  if (document.querySelector('[data-bhd-wishlist-page]')) {
    let wishlistRetryCount = 0;
    const wishlistRetry = window.setInterval(() => {
      wishlistRetryCount += 1;
      gateWishlist();
      if (wishlistRetryCount >= 20) window.clearInterval(wishlistRetry);
    }, 500);
  }
})();
